import React from 'react';

import * as S from './HotelRoomDetail.styles';

import FareBreakup from '../FareBreakup/FareBreakup';

import RupeeIcon from '../../../../Icons/RupeeIcon';

const HotelRoomDetail = ({details, priceInfo, fareBreakup}) => {
  return (
    <S.BookedHtlRoomInfoWrap>
      <S.BookedHtlRoomInfoInnerWrap>
      {details.rooms && details.rooms.length && details.rooms.map((room) =>
        <S.BookedHtlRoomDetailInnerWrap key={room.room_type_name}>
          <S.BookedHtlRoomNameWrap>
              <S.BookedHtlRoomName>{room.room_type_name}</S.BookedHtlRoomName>
          </S.BookedHtlRoomNameWrap>
          <S.BookedHtlRoomAmenitiesWrap>
              <S.BookedHtlRoomAmenitesText>
                {room.perks && room.perks.map((item, index) => {
                  return <span key={`perks${index}`}>{index > 0 ? ', ' : ''} {item}</span>;
                })}
              </S.BookedHtlRoomAmenitesText>
          </S.BookedHtlRoomAmenitiesWrap>
        </S.BookedHtlRoomDetailInnerWrap>
      )}
      </S.BookedHtlRoomInfoInnerWrap>

      <S.BookedHtlRoomPriceInfoWrap>
          <S.BookedHtlPriceText>
            <RupeeIcon width="1.8rem" height="1.8rem" />{priceInfo.total ? priceInfo.total.toLocaleString('en-IN') : ''}
          </S.BookedHtlPriceText>
          <S.BookedPirceTaxText>Inclusive of all taxes</S.BookedPirceTaxText>
          <S.FareDetailWrap>
            <S.FareDetailText>Fare Details</S.FareDetailText>
            <FareBreakup totalAmount={priceInfo.total} fareBreakup={fareBreakup} />
          </S.FareDetailWrap>
      </S.BookedHtlRoomPriceInfoWrap>
    </S.BookedHtlRoomInfoWrap>
  );
};

export default HotelRoomDetail;
